import { Component } from '@angular/core';

@Component({
    selector: 'app-trustedusers',
    imports: [],
    templateUrl: './trustedusers.component.html',
    styleUrl: './trustedusers.component.css'
})
export class TrustedusersComponent {

}
